
import request from '../../request';
import { textToSpeech } from '../../endpoints';

export default class textToSpeechApi {
  static async getQuestionTextToSpeech({ text, languageCode, surveyId, questionId, gender, audience }) {
    return request({
      url: textToSpeech.getQuestionTextToSpeech(),
      method: 'POST',
      data: { text, languageCode, surveyId, questionId, gender, audience },
      responseType: 'blob',
    });
  }

  static async getWelcomeTextToSpeech({ text, languageCode, surveyId, gender }) {
    return request({
      url: textToSpeech.getWelcomeTextToSpeech(),
      method: 'POST',
      data: { text, languageCode, surveyId, gender },
      responseType: 'blob',
    });
  }
}
